import { Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';

export const ToggleButtonWrapper = styled(Glyphicon).attrs<{
  $isExpanded: boolean;
  $vertical: boolean;
}>(({ $isExpanded, $vertical }) => ({
  glyph: $isExpanded
    ? $vertical
      ? 'chevron-up'
      : 'chevron-right'
    : $vertical
    ? 'chevron-down'
    : 'chevron-left',
}))`
  color: black;
`;
